import React from 'react';
import { Button as DefaultButton } from 'framework/ui/mui-builder';
import { useAuthorization } from '../../authorization';
import { useListContext } from 'framework/list';
import { TimelineRegistry } from './timelineRegistryHelper';
import AddIcon from '@mui/icons-material/AddOutlined';
import { useUiTheme } from 'framework/uiTheme';

type AddTimelineItemInputProps = {
  registries: TimelineRegistry[];
  selectItemCallback: (registry: TimelineRegistry) => void;
};

type RegistriesMap = Dictionary<TimelineRegistry>;

const AddTimelineItemInput = ({ registries, selectItemCallback }: AddTimelineItemInputProps) => {
  const { Button: ThemedButton } = useUiTheme();
  const Button = ThemedButton || DefaultButton;
  const { isGranted } = useAuthorization();
  const { data } = useListContext();
  const registriesMap: RegistriesMap = {};

  registries.forEach(registry => {
    registriesMap[registry.name] = registry;
  });

  const onButtonClick = (registryName: string) => {
    selectItemCallback(registriesMap[registryName]);
  };

  const getButtonLayout = ({ name, source, buttonSize }: TimelineRegistry) => (
    <Button
      onClick={() => {
        onButtonClick(name);
      }}
      key={`btn-${source}`}
      startIcon={<AddIcon />}
      size={buttonSize}
    >
      {name}
    </Button>
  );

  const buttons = registries
    .filter(registry => !registry.permissionToCheck || isGranted(registry.permissionToCheck))
    .filter(registry => !registry.withoutAddFunctionality)
    .filter(
      registry => !registry.hideAddWhenItemExists || !(data?.items || []).some(item => registry.isApplicable(item)),
    )
    .map(registry => getButtonLayout(registry));

  return <>{buttons.length ? buttons : null}</>;
};

export default AddTimelineItemInput;
